import styled from "styled-components";
import {Button, Card, Flex, Heading, Text} from "rebass";
import {maxHeight} from "styled-system";
import React from "react";
import MdAdd from "react-ionicons/lib/MdAdd";
import {Overlay} from "reakit";


export const StyledButton = styled(Button)`
  height: 30px;
  max-width: 29px;
  svg {
    color: white;
  }
`;

export const Title = ({children})=> <Heading as={'h3'} mb={'14px'}>{children}</Heading>


export const Column = styled(Flex)`
box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
min-width: 1243px;
`;

Column.defaultProps = {
	flexDirection: ['column'],
	flexWrap: 'wrap',
	width: 1,
	m: 0
};


export const TableHorizontalScroll = styled(Flex)`
  display: flex; /* [1] */
  flex-wrap: nowrap; /* [1] */
  overflow-y: visible; /* [1] */
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  ::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
`;

export const TableHeader = styled(Flex)`
// max-height: 92px;
`

export const PanelWrapper = styled(Card)`
//min-width: 250px;
//	height: calc(100vh - 131px);
//	margin-bottom: 10px;
	max-height: calc(45vh - 65px);
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  //@media(max-width: 700px){
  //	height: 70vh;
  //
  //}
  ${maxHeight}
`;


export const PlusIcon = styled(MdAdd)`
	margin: 0;
	padding: 0;
	margin-top: 5px;
	margin-left: -8px;
`

PlusIcon.defaultProps = {
	fontSize: '23px',
	color: 'white'
};

export const IconText = styled(Text)`
	margin-top: -10px !important;
	margin-left: -3px;
`

export const DetailsOverlay = styled(Overlay)`
width: 50%;
height: auto;
	@media(max-width: 700px){
	width: 100%;
height: 100%;
	}
`;